import { AxiosRequestConfig } from 'axios'
import { tokenBaseURL } from 'core/api'
import HttpClient from 'core/axios'
import { getAccessToken } from 'core/singleton'

class KbpayApiClient extends HttpClient {
  constructor() {
    super(tokenBaseURL)
    this.initializeRequestInterceptor()
  }

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest, this.handleError)
  }

  private handleRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    config.headers['X-SauceFlex-Authorize'] = getAccessToken()
    return config
  }
}

const kbpayApiClient = new KbpayApiClient()

export default kbpayApiClient
